<i class="font-icon reference" [ngClass]="iconClass()" (mouseover)="handleMouseOver($event)"> </i>
